export const accountStatusKeys = ["ACTIVE", "BLOCK"];
export const accountStatusLabels = {
    ACTIVE: "Активен",
    BLOCK: "Заблокирован",
};
export const accountStatusItems = accountStatusKeys.map((key) => {
    return {
        value: key,
        label: accountStatusLabels[key],
    };
});
//# sourceMappingURL=accountStatus.js.map